/* Promo TV Selectron · interacciones mínimas (sin librerías). La página funciona sin JS.
   Sección: sections/selectron-promo.liquid. Se inicializa una vez por cada .sx de la página. */
(function () {
  function init(root) {
    if (root.dataset.sxReady) return;
    root.dataset.sxReady = '1';
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var $$ = function (q) { return [].slice.call(root.querySelectorAll(q)); };

    // 1. Filtro de fichas (Todos / sistema / tamaño)
    var chips = $$('.sx-chip'), cards = $$('.sx-card'), offers = root.querySelector('#ofertas');
    function filt(f) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.f === f); });
      cards.forEach(function (c) { c.hidden = !(f === 'all' || c.dataset.os === f || c.dataset.size === f); });
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { filt(c.dataset.f); }); });
    $$('[data-go]').forEach(function (b) {
      b.addEventListener('click', function () {
        filt(b.dataset.go);
        if (offers) offers.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    if (!('IntersectionObserver' in window)) return;

    // 2. Sub-menú: marca la sección visible
    var links = $$('.sublink');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id); });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) { var t = root.querySelector(a.getAttribute('href')); if (t) io.observe(t); });

    // 3. Sub-menú Selectron y barra de compra móvil: aparecen solo al pasar el hero (no se duplican con el header ni con el banner)
    //    El header del tema es fijo: el sub-menú se pega debajo de él (--sx-top) y los anclajes descuentan los dos.
    var hero = root.querySelector('.sx-car'), hds = [].slice.call(document.querySelectorAll('header.header, .mobile-header')), raf = 0;
    function top() {
      raf = 0;
      var y = 0;
      hds.forEach(function (hd) {
        var r = hd.getBoundingClientRect();
        if (r.height && /fixed|sticky/.test(getComputedStyle(hd).position)) y = Math.max(y, Math.round(r.bottom));
      });
      root.style.setProperty('--sx-top', y + 'px');
    }
    function queue() { if (!raf) raf = requestAnimationFrame(top); }
    top();
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue);
    [root.querySelector('.mbar'), root.querySelector('.sx-sub')].forEach(function (el) {
      if (el && hero) new IntersectionObserver(function (es) {
        var e = es[0];
        el.classList.toggle('sx-show', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(hero);
    });

    // 4. Contadores de datos clave
    var counts = $$('.count');
    if (counts.length && !reduce) {
      var o = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        o.disconnect();
        var t0 = performance.now();
        (function step(t) {
          var p = Math.min(1, (t - t0) / 1400), k = 1 - Math.pow(1 - p, 3);
          counts.forEach(function (c) { c.textContent = Math.round(+c.dataset.to * k); });
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      }, { threshold: .5 });
      o.observe(counts[0].closest('section'));
    }

    // 5. Carrusel del hero: 8 s por banner, se detiene con hover/foco, fuera de pantalla, pausa o movimiento reducido
    if (!hero) return;
    var car = hero, sl = [].slice.call(car.querySelectorAll('.sx-slide')), dots = [].slice.call(car.querySelectorAll('.sx-dot'));
    var i = 0, t = null, user = false, vis = true, hover = false, DUR = 8000;
    if (sl.length < 2) return;
    function restart(el) { if (el.getAnimations) el.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); a.play(); }); }
    function playing() { return !user && !reduce && vis && !hover; }
    function bar() { var b = car.querySelector('.sx-dot[aria-current="true"] i'); if (b) { b.style.animation = 'none'; void b.offsetWidth; b.style.animation = ''; } }
    function sched() {
      clearTimeout(t);
      car.classList.toggle('is-stopped', !playing());
      sl[i].querySelector('.bnr').classList.toggle('is-paused', !vis);
      if (playing()) { bar(); t = setTimeout(function () { show(i + 1); }, DUR); }
    }
    function show(n) {
      n = (n + sl.length) % sl.length;
      sl.forEach(function (s, k) {
        var on = k === n;
        s.classList.toggle('on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelector('.bnr').classList.toggle('is-paused', !on);
        [].forEach.call(s.querySelectorAll('a'), function (a) { a.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === n ? 'true' : 'false'); });
      if (n !== i) restart(sl[n]);
      i = n;
      sched();
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    car.querySelector('[data-car=prev]').addEventListener('click', function () { show(i - 1); });
    car.querySelector('[data-car=next]').addEventListener('click', function () { show(i + 1); });
    var pb = car.querySelector('[data-car=pause]');
    pb.addEventListener('click', function () {
      user = !user;
      car.classList.toggle('is-user', user);
      pb.setAttribute('aria-pressed', user);
      pb.setAttribute('aria-label', user ? 'Reanudar carrusel' : 'Pausar carrusel');
      sl[i].querySelector('.bnr').classList.toggle('is-paused', user);
      sched();
    });
    var track = car.querySelector('.sx-car-track');
    track.addEventListener('mouseenter', function () { hover = true; sched(); });
    track.addEventListener('mouseleave', function () { hover = false; sched(); });
    car.addEventListener('focusin', function () { hover = true; sched(); });
    car.addEventListener('focusout', function () { hover = false; sched(); });
    new IntersectionObserver(function (e) { vis = e[0].isIntersecting; sched(); }, { threshold: .15 }).observe(car);
    show(0);
  }

  function boot() { [].forEach.call(document.querySelectorAll('.sx'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Editor de temas: volver a iniciar cuando se recarga la sección
  document.addEventListener('shopify:section:load', boot);
})();
